import { ApplicationState } from '@/store';
import { DependencyList, useEffect } from 'react';
import { useSelector } from 'react-redux';

type Props = {
    onChange: () => void;
};

export const useSystemLanguageChange = ({ onChange }: Props, dependencies: DependencyList = []) => {
    const language = useSelector((state: ApplicationState) => state.locale.data._LANGUAGE);

    useEffect(onChange, [language, ...dependencies]);
};
